const manageStudent = {
    namespaced : true,
    state : {
        listStudents: [],
        coursesOnline: [],
        showDetail: false,
        showWrongAnswer: false,
        loadingStudent: false,
        loadingLesson: false,
        loadingAttendance: false,
        courseOnlineList: [],
        showAll: false
    },
    mutations : {
        setListStudents(state, payload) {
            state.listStudents = payload;
        },
        setShowDetail(state, payload) {
            state.showDetail = payload;
        },
        setShowWrongAnswer(state, payload) {
            state.showWrongAnswer = payload;
        },
        setShowCoursesOnline(state, payload) {
            state.coursesOnline = payload;
        },
        setLoadingStudent(state, payload) {
            state.loadingStudent = payload;
        },
        setLoadingLesson(state, payload) {
            state.loadingLesson = payload;
        },
        setLoadingAttendance(state, payload) {
            state.loadingAttendance = payload;
        },
        setCourseOnlineList(state, payload) {
            state.courseOnlineList = payload;
        },
        setShowAll(state, payload) {
            state.showAll = payload;
        },
    },
    actions: {
        saveDetailJoin: function ({ state, commit }, data) {
            let courses = state.courseOnlineList

            // Kiểm tra ID khóa học
            let key = courses.findIndex(course => course.courseLiveId ==  data.courseLiveId);
            if (key >= 0) {

                // Lưu tạm
                courses[key].totalStudentJoin = data.totalStudentJoin;
                courses[key].totalStudentNoJoin = data.totalStudentNoJoin;
            }

            // Lưu dữ liệu vào store
            commit("setCourseOnlineList", courses);
        }
    },
    getters : {
        getListStudents (state) {
            return state.listStudents;
        },
        getShowDetail(state) {
            return state.showDetail;
        },
        getShowWrongAnswer(state) {
            return state.showWrongAnswer;
        },
        getShowCoursesOnline(state) {
            return state.coursesOnline;
        },
        getLoadingStudent(state) {
            return state.loadingStudent;
        },
        getLoadingLesson(state) {
            return state.loadingLesson;
        },
        getLoadingAttendance(state) {
            return state.loadingAttendance;
        },
        getCourseOnlineList(state) {
            return state.courseOnlineList;
        },
        getShowAll(state) {
            return state.showAll;
        }
    }
};

export default manageStudent;


// WEBPACK FOOTER //
// ./src/stores/modules/manageStudent.js